export default __webpack_public_path__ + "static/media/payment-method-truck-desktop.130393cb.png";